import React from 'react';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const ContactSection = ({ onBookDemo, onEnquiry }) => {
  return (
    <section id="contact" className="py-32 bg-[#121212] relative overflow-hidden">
      {/* Background accent */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#06B6D4]/30 to-transparent"></div>
      <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#06B6D4]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Left - Contact Info */}
          <div>
            <span className="text-[#06B6D4] text-sm font-medium tracking-wider uppercase mb-4 block">
              Get in Touch
            </span>
            <h2 className="text-4xl lg:text-5xl font-semibold text-white mb-6">
              Let's Build Something
              <br />
              <span className="text-[#06B6D4]">Amazing Together</span>
            </h2>
            <p className="text-xl text-white/60 leading-relaxed mb-10">
              Ready to transform your business with cutting-edge technology? 
              Get in touch with our team of experts today.
            </p>

            {/* Contact Details */}
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#06B6D4]/10 flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-[#06B6D4]" />
                </div>
                <div>
                  <h4 className="text-white font-medium mb-1">Email Us</h4>
                  <a href={`mailto:${companyInfo.email}`} className="text-white/60 hover:text-[#06B6D4] transition-colors">
                    {companyInfo.email}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#06B6D4]/10 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-5 h-5 text-[#06B6D4]" />
                </div>
                <div>
                  <h4 className="text-white font-medium mb-1">Call Us</h4>
                  <a href={`tel:${companyInfo.phone}`} className="text-white/60 hover:text-[#06B6D4] transition-colors">
                    {companyInfo.phone}
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#06B6D4]/10 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5 text-[#06B6D4]" />
                </div>
                <div>
                  <h4 className="text-white font-medium mb-1">Location</h4>
                  <p className="text-white/60">
                    {companyInfo.address}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - CTA Cards */}
          <div className="space-y-6">
            {/* Book Demo Card */}
            <div 
              onClick={onBookDemo}
              className="group bg-black border border-white/10 p-8 cursor-pointer transition-all duration-400 hover:border-[#06B6D4]/50"
            >
              <h3 className="text-2xl font-semibold text-white mb-3 group-hover:text-[#06B6D4] transition-colors">
                Book a 1-on-1 Demo
              </h3>
              <p className="text-white/60 mb-6">
                Schedule a personalized demo session with our experts to explore how our solutions can benefit your business.
              </p>
              <div className="flex items-center gap-2 text-[#06B6D4]">
                <span className="font-medium">Schedule Now</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
              </div>
            </div>

            {/* Enquiry Card */}
            <div 
              onClick={onEnquiry}
              className="group bg-[#06B6D4] p-8 cursor-pointer transition-all duration-400 hover:bg-[#0891b2]"
            >
              <h3 className="text-2xl font-semibold text-black mb-3">
                Send an Enquiry
              </h3>
              <p className="text-black/70 mb-6">
                Have a specific project in mind? Send us your requirements and we'll get back to you within 24 hours.
              </p>
              <div className="flex items-center gap-2 text-black">
                <span className="font-medium">Get Started</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
